<script>
import {ref} from "vue";
import useTools from "@/use/Tools";
import useValidation from "@/use/Validation";
import useSharedData from "@/use/SharedData";
import axios from "axios";
import ImportModel from "@/views/Tools/Components/ImportModel.vue";
import {useSecurityStore} from "@/stores/Security";
import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {ImportModel},
    setup() {
        const {mxRules} = useValidation();
        const {$swal, $i18n} = useTools();
        const {formatedDate} = useSharedMethod();
        const securityStore = useSecurityStore();
        const {dialog, loading,} = useSharedData();
        dialog.value = false;

        const file = ref(null);
        const contrats = ref([]);
        const search = ref(null);
        const logDialog = ref(false);
        const logs = ref([]);

        const headers = [
            {
                text: $i18n.t("contrat.number"),
                align: "start",
                sortable: true,
                value: "number",
            },

            {
                text: $i18n.t("module.worker"),
                align: "start",
                sortable: false,
                value: "workerLastName",
            },
            {
                text: $i18n.t("module.state"),
                align: "start",
                sortable: true,
                value: "status",
            },
            {
                text: $i18n.t("module.contrat_template"),
                align: "start",
                sortable: true,
                value: "contratTemplateName",
                width: "100px",
            },
            {
                text: $i18n.t("contrat.start"),
                align: "start",
                sortable: true,
                value: "start",
            },
            {
                text: $i18n.t("contrat.end"),
                align: "start",
                sortable: true,
                value: "end",
            },
            {
                text: $i18n.t("contrat.duration"),
                align: "start",
                sortable: true,
                value: "duration",
            },
            {
                text: $i18n.t("module.contrat_characteristic"),
                align: "start",
                sortable: true,
                value: "natureName",
            },
            {
                text: $i18n.t("contrat.trial_period_duration"),
                align: "start",
                sortable: true,
                value: "trialPeriodDuration",
            },
            {
                text: "Fin Pèriode D'essai",
                align: "start",
                sortable: true,
                value: "trialPeriodEnd",
            },
            {
                text: "Etat Pèriode D'essai",
                align: "start",
                sortable: true,
                value: "trialPeriodValidated",
            },
            {
                text: $i18n.t("contrat.end_renewed_trial_period"),
                align: "start",
                sortable: true,
                value: "endRenewedTrialPeriod",
            },
            {
                text: $i18n.t("contrat.contrat_leaving_reason_name"),
                align: "start",
                sortable: true,
                value: "exitRationaleName",
            },
            {
                text: "Date Résiliation",
                align: "start",
                sortable: true,
                value: "leavingDate",
            },
        ];


        function upload() {
            loading.value = true;
            let formData = new FormData();
            formData.append('file', file.value);
            axios.post(`/tools/getContrats`, formData).then(response => {
                contrats.value = response.data.elements;
                logs.value = response.data.logs;
                dialog.value = false;
                file.value = null;
                if (logs.value.length > 0)
                    logDialog.value = true;
            }).finally(() => {
                loading.value = false;
            });
        }

        function apply() {
            loading.value = true;
            axios.post(`/contrats/saveAll`, contrats.value).then(() => {
                $swal.fire('Très Bien', "Importation des modèles terminer", 'success')
                contrats.value = [];
                logs.value = [];
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            securityStore,
            mxRules,
            dialog,
            loading,
            headers,
            file,
            search,
            contrats,
            logDialog,
            logs,
            formatedDate,
            apply,
            upload,
        }
    }
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.contrat_tools')"
            show-total
            :total="contrats.length"
        >
            <template v-slot:leftToolbar>
                <ImportModel file-name="Contrat.xlsx"/>
            </template>
            <template v-slot:rightToolbar>
                <w-btn-import
                    @press="dialog = true"
                />
                <w-btn
                    color="orange"
                    icon="mdi-skull-scan"
                    :text="$t('common.logs')"
                    @press="logDialog = true"
                />
                <w-btn
                    v-if="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                    color="red"
                    icon="mdi-table-check"
                    :text="$t('common.apply')"
                    :loading="loading"
                    @press="apply"
                />

            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field v-model="search" :label="$t('common.search')"/>
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    identity="number"
                    :search="search"
                    :items="contrats"
                    :loading="loading"
                >
                    <template v-slot:[`item.number`]="{ item }">
                        <w-chip color="teal" :text="item.number"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-chip color="blue" :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <w-chip outlined :text="$t(`contrat.${item.status}`)"/>
                    </template>
                    <template v-slot:[`item.contratTemplateName`]="{ item }">
                        <w-chip outlined :text="item.contratTemplateName"/>
                    </template>
                    <template v-slot:[`item.start`]="{ item }">
                        <w-chip color="blue" :text="formatedDate(item.start)"/>
                    </template>
                    <template v-slot:[`item.end`]="{ item }">
                        <w-chip color="orange" :text="formatedDate(item.end)"/>
                    </template>
                    <template v-slot:[`item.duration`]="{ item }">
                        <w-chip
                            outlined
                            :text="item.determinedTime ? `${item.duration} ${$t(`common.${item.periodicity}`)}` : $t('contrat.cdi')"
                        />
                    </template>
                    <template v-slot:[`item.natureName`]="{ item }">
                        <w-chip outlined :text="item.natureName"/>
                    </template>
                    <template v-slot:[`item.trialPeriodDuration`]="{ item }">
                        <w-chip
                            outlined
                            :text="item.trialPeriod ? `${item.trialPeriodDuration} ${$t(`common.${item.trialPeriodPeriodicity}`)}` : $t('contrat.without_trial_period')"
                        />
                    </template>
                    <template v-slot:[`item.trialPeriodEnd`]="{ item }">
                        <w-chip outlined :text="formatedDate(item.trialPeriodEnd)"/>
                    </template>
                    <template v-slot:[`item.trialPeriodValidated`]="{ item }">
                        <v-icon color="teal" v-if="item.trialPeriodValidated">mdi-check-decagram</v-icon>
                        <v-icon color="red" v-else>mdi-check-decagram</v-icon>
                    </template>
                    <template v-slot:[`item.endRenewedTrialPeriod`]="{ item }">
                        <w-chip outlined :text="formatedDate(item.endRenewedTrialPeriod)"/>
                    </template>
                    <template v-slot:[`item.exitRationaleName`]="{ item }">
                        <w-chip color="red" :text="item.exitRationaleName"/>
                    </template>
                    <template v-slot:[`item.leavingDate`]="{ item }">
                        <w-chip color="red" :text="formatedDate(item.leavingDate)"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="700"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.import')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <strong>{{ $t('common.file') }} *</strong>
                                <w-file-input
                                    v-model="file"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn-import
                        :loading="loading"
                        @press="upload"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="logDialog"
            max-width="600"
            scrollable
        >
            <v-card>
                <w-toolbar color="orange" title="Logs"/>
                <v-card-text>
                    <v-container fluid>
                        <v-list dense>
                            <v-list-item
                                v-for="(log, index) in logs"
                                :key="`log-${index}`"
                            >
                                <v-list-item-title>{{ log }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>